var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D96C0AB6-4DD5-436D-9A24-A273C811AC26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Mini-Survey---Empty",
    transform: "translate(-701.000000, -636.000000)",
    fill: "#CDCDCD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "progress-empty",
    transform: "translate(701.000000, 636.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2246094,0 C24.4959082,0 23.90625,0.589658203 23.90625,1.31835938 L23.90625,19.8632812 C23.90625,20.5919824 24.4959082,21.1816406 25.2246094,21.1816406 L43.6816406,21.1816406 C44.4103418,21.1816406 45,20.5919824 45,19.8632812 C45,8.95851562 36.129375,0 25.2246094,0",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6669229,42.0439922 L21.26954,24.8972344 L21.26954,6.67970508 C21.26954,5.95100391 20.6798818,5.3613457 19.9511807,5.3613457 C9.04641504,5.3613457 8.7890625e-06,14.2319707 8.7890625e-06,25.1367363 C8.7890625e-06,36.041502 9.04641504,45.0000176 19.9511807,45.0000176 C22.3381143,45.0000176 24.6748623,44.5763848 26.8957705,43.7420391 C27.576835,43.4859258 27.9218936,42.7262871 27.6669229,42.0439922",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6816406,23.8183594 L25.2246094,23.8183594 C24.7920117,23.8183594 24.3878027,24.030791 24.1405664,24.3861328 C23.8946484,24.7414746 23.8380469,25.1946387 23.9899219,25.600166 L30.4709766,42.970957 C30.5945508,43.297998 30.8417871,43.5631641 31.1610937,43.7073926 C31.4805762,43.8526758 31.8405762,43.8649805 32.1704297,43.7408789 C39.8437207,40.8530566 45,33.3249609 45,25.1367188 C45,24.4080176 44.4103418,23.8183594 43.6816406,23.8183594",
    id: "Fill-6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressEmpty);
export default __webpack_public_path__ + "static/media/progress-empty.d001cdbe.svg";
export { ForwardRef as ReactComponent };